$(document).ready(function () {
    initProduct();
    initSelects();
    initBrands();
    initRows();
    initCart();
    initFilters();
    initOrderForm();
    initFooter();
    initMobile();
    initTables();
});

function resize() {
    initTables();
    initMobileCart();
    initProduct();
}

var timo;
window.onresize = function () {
    clearTimeout(timo);
    timo = setTimeout(resize, 100);
};

$('.navbar-toggler').click(function () {
    $(this).toggleClass('active');
    $('body').toggleClass('no-scroll');
});

function initSelects() {
    var selects = $('select.styled:not(.done)');

    selects.each(function () {
        $(this).wrap('<div class="select-wrap"></div>');
        var wrap = $(this).parent();
        var selected = $(this).find(':selected');
        selected.attr('selected', true);
        wrap.css('max-width', $(this).outerWidth());


        var img = selected.data('image');
        var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';

        wrap.append('<div class="select-value' + (img ? ' has-image' : '') + '">' + (img ? bg : '') + selected.text() + '</div>');
        var html = '<div class="select-options">';
        $(this).find('option').each(function () {
            var img = $(this).data('image');
            var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';
            html += '<div class="option ' +
                $(this).attr('class') +
                ($(this).attr('selected') ? ' selected' : '') + '"' +
                ' data-value="' + $(this).val() + '">' +
                (img ? bg : '') +
                $(this).text() +
                '</div>';
        });
        html += "</div>";
        wrap.append(html);
        wrap.addClass($(this).attr('class'));
        $(this).addClass('done');

        if ($('.select-options', wrap).outerHeight() >= parseInt($('.select-options', wrap).css('max-height'))) {
            $('.select-options', wrap).mCustomScrollbar();
        }

        if (wrap.find('select').val() == $('option', wrap).eq(0).val()) {
            wrap.addClass('default');
        }
    });

    $('.select-wrap').each(function () {
        var value = $('.select-value', $(this));
        var opts = $('.option', $(this));
        var img = value.data('image');


        if (img != '' && typeof img != 'undefined' && (value.css('background-image') == '' || value.css('background-image') == 'none')) {
            var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';
            value.addClass('has-image');
            value.prepend(bg);
        }

        opts.each(function () {
            var img = $(this).data('image');
            if (img != '' && typeof img != 'undefined' && $(this).find('.bg-ico').length == 0) {
                var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';
                $(this).prepend(bg);
            }
        });

    });

    $('select.styled').click(function () {
        $(this).parent().focus().toggleClass('clicked');
    });

    $('.select-value').click(function () {
        $(this).parent().focus().toggleClass('clicked');
    });

    var options = $('.select-options .option');
    options.click(function () {
        var wrap = $(this).parents('.select-wrap');
        var img = $(this).find('.bg-ico').css('background-image');
        var bg = $('<div class="bg-ico"></div>').css('background-image', img);
        wrap.removeClass('clicked').find('.select-value').html($(this).text());
        wrap.find('.select-value').removeClass('has-image');
        if (img) {
            wrap.find('.select-value').addClass('has-image').prepend(bg);
        }
        wrap.find('select').val($(this).attr('data-value')).change();
        $('.option', wrap).removeClass('selected');
        $(this).addClass('selected');

        if (wrap.find('select').val() == $('option', wrap).eq(0).val()) {
            wrap.addClass('default');
        }
        else {
            wrap.removeClass('default');
        }

    });

    $('.select-wrap').attr('tabindex', '1').focusout(function () {
        $(this).removeClass('clicked');
    });

    //find option by pressed keys
    var typingTimer;
    var doneTypingInterval = 700;
    var needle = '';

    $(".select-wrap").keypress(function (e) {
        needle += e.key;
        clearTimeout(typingTimer);
        selectWrap = $(this);

        typingTimer = setTimeout(function () {
            doneTyping(selectWrap);
        }, doneTypingInterval);
    });

    function doneTyping(selectWrap) {
        var opt = $('.option', selectWrap).filter(function () {
            var text = $(this).text().toLowerCase().replace(/\s/g, '');
            needle = needle.replace(/\s/g, '');
            return text.indexOf(needle) === 0;
        });
        if (opt.length > 0) {
            selectWrap.find('select-options').mCustomScrollbar('scrollTo', opt.eq(0).position().top);
            opt.eq(0).click();
        }
        needle = '';
    }
}

function initBrands() {
    $('.brands .brand-wrap').addClass('owl-carousel').owlCarousel({
        items: 8,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 3,
            },
            320: {
                items: 4
            },
            480: {
                items: 5,
            },
            575: {
                items: 5
            },
            680: {
                items: 6
            },
            800: {
                items: 7
            },
            1000: {
                items: 8
            }

        }
    });
}

function initRows() {
    initProductRow();
    initCategoryRow();

    function initProductRow() {

        $('.list-row .product-wrap').each(function () {
            var prodWidth = 0;

            $('.product', $(this)).each(function () {
                prodWidth += $(this).outerWidth() + 20;
            });

            if ($(this).width() >= prodWidth) {
                return;
            }

            var owl = $(this).addClass('owl-carousel').owlCarousel({
                items: 6,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 2,
                        slideBy: 2
                    },
                    550: {
                        items: 3,
                        slideBy: 3
                    },
                    650: {
                        items: 4,
                        slideBy: 4
                    },
                    800: {
                        items: 5,
                        slideBy: 5
                    },
                    900: {
                        items: 6,
                        slideBy: 6
                    }
                }
            });
            addControls(owl);
        });
    }

    function initCategoryRow() {

        $('.list-row .category-wrap').each(function () {
            var catWidth = 0;

            $('.category', $(this)).each(function () {
                catWidth += $(this).outerWidth() + 10;
            });

            if ($(this).width() >= catWidth) {
                return;
            }

            var owl = $(this).addClass('owl-carousel').owlCarousel({
                items: 4,
                loop: true,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 1,
                        slideBy: 1
                    },
                    360: {
                        items: 1.3,
                    },
                    420: {
                        items: 1.5,
                    },
                    480: {
                        items: 1.7,
                    },
                    520: {
                        items: 2,
                        slideBy: 2
                    },
                    580: {
                        items: 2.2,
                        slideBy: 2
                    },
                    620: {
                        items: 2.4,
                        slideBy: 2
                    },
                    660: {
                        items: 2.6,
                        slideBy: 2
                    },
                    700: {
                        items: 2.8,
                        slideBy: 2
                    },
                    740: {
                        items: 3,
                        slideBy: 3
                    },
                    900: {
                        items: 3.3,
                        slideBy: 3
                    },
                    950: {
                        items: 3.7,
                        slideBy: 3

                    },
                    1050: {
                        items: 4,
                        slideBy: 4
                    }
                }
            });
            addControls(owl);
        });
    }

    function addControls(owl) {
        owl.siblings('header').find('.owl-custom-controls').addClass('show').find('.owl-custom-control').click(function () {
            if ($(this).hasClass('next')) {
                owl.trigger('next.owl.carousel');
            } else {
                owl.trigger('prev.owl.carousel');
            }
        });
    }
}

function initCart() {
    initBigCart();


    function initBigCart() {
        initDeliveryBlock();
        initCounts();

        function initDeliveryBlock() {
            var wrap = $('.delivery-block');
            var discountToggle = $('.discount-toggle');
            var discountInput = $('#discount-code');
            var spinner = $('.loading');
            var inputWrap = $('.input-wrap', wrap);
            var discountUse = $('.discount-use', wrap);
            var timo = null;
            var deliveryType = $('#delivery-type', wrap);

            discountToggle.click(function () {
                $(this).closest('.discount-wrap').toggleClass('show');
            });

            //remove me --
            data = new Object({
                valid: false,
                errorMessage: "Promo kods netika atrasts"
            });
            //--

            discountInput.keyup(function () {
                if (timo != null) {
                    clearTimeout(timo);
                }

                if ($(this).val() == '') {
                    inputWrap.removeClass('valid invalid');
                    return;
                }

                timo = setTimeout(function () {
                    timo = null;
                    spinner.addClass('show');
                    inputWrap.removeClass('valid invalid');

                    //uncomment and edit me
                    // $.ajax({
                    //     url: '?',
                    //     method: 'POST',
                    //     data: {
                    //         'action': 'validate-discount',
                    //         'discount-code': discountInput.val()
                    //     },
                    //     success: function (data) {
                    //         data = $.parseJSON(data);
                    //         spinner.removeClass('show');
                    //         if (data.valid == true) {
                    //             $('.error', wrap).hide();
                    //             inputWrap.removeClass('valid invalid');
                    //             inputWrap.addClass('valid');
                    //         } else {
                    //             if(data.errorMessage){
                    //                 $('.error', wrap).text(data.errorMessage);
                    //             }
                    //             $('.error', wrap).show();
                    //             inputWrap.removeClass('valid invalid');
                    //             inputWrap.addClass('invalid');
                    //         }
                    //     },
                    // });

                    //mocking ajax. remove me--
                    setTimeout(function () {
                        data.valid = data.valid ? false : true;

                        spinner.removeClass('show');
                        if (data.valid == true) {
                            $('.error', wrap).hide();
                            inputWrap.removeClass('valid invalid');
                            inputWrap.addClass('valid');
                        } else {
                            if (data.errorMessage) {
                                $('.error', wrap).text(data.errorMessage);
                            }
                            $('.error', wrap).show();
                            inputWrap.removeClass('valid invalid');
                            inputWrap.addClass('invalid');
                        }
                    }, 1000);
                    //--

                }, 300);
            });

            deliveryType.change(function () {
                alert('nez, te jābūt ajaxam vai viss jāieliek formā');
            });
        }

        function initCounts(){
            var wrap = $('.cart-wrap');
            var selectors = '.cart-table .count-button, .new-table .count-button';

            wrap.on('click', selectors, function(){
                var dir = $(this).hasClass('plus') ? 1 : -1;
                var input =  $(this).siblings('input.count');

                if(dir == -1 && input.val() <= input.attr('min')){
                    return false;
                }
                input.val(parseInt(input.val())+dir).change();

                return false;
            });

            wrap.on('change', 'input.count', function(){
                var row = $(this).closest('[data-product-id]');
                var otherRow = wrap.find('[data-product-id='+row.data('product-id')+']').not(row);

                otherRow.find('input.count').val($(this).val());
            })
        }
    }
}

function initFilters() {
    initPriceFilter();


    function initPriceFilter() {
        if ($("#filter-price-slider").length < 1) {
            return;
        }
        var sldr = $("#filter-price-slider").slider(
            $.extend({
                range: true,
                stop: sliderChange,
                animate: "fast"
            }, priceFilterParams)
        );
        var wrap = sldr.parent();
        var priceFrom = $('[name="price-from"]', wrap);
        var priceTo = $('[name="price-to"]', wrap);
        var timo = null;

        priceFrom.keyup(function () {
            inputChange($(this));
        });
        priceTo.keyup(function () {
            inputChange($(this));
        });

        function sliderChange() {
            priceFrom.val(sldr.slider('option', 'values')[0]);
            priceTo.val(sldr.slider('option', 'values')[1]);
        };

        function inputChange(target) {
            if (timo != null) {
                clearTimeout(timo);
            }

            timo = setTimeout(function () {
                timo = null;

                if (parseInt(priceFrom.val()) > parseInt(priceTo.val())) {
                    if (target.get(0) == priceFrom.get(0)) {
                        priceFrom.val(priceTo.val()).trigger('keyup');
                    } else {
                        priceTo.val(priceFrom.val()).trigger('keyup');
                    }
                    return;
                }

                if (target.get(0) == priceFrom.get(0)) {
                    sldr.slider('values', [priceFrom.val(), sldr.slider('option', 'values')[1]]);
                } else if (target.get(0) == priceTo.get(0)) {
                    sldr.slider('values', [sldr.slider('option', 'values')[0], priceTo.val()]);
                }
            }, 200);
        }
    }
}

function initOrderForm() {
    var wrap = $('.order-wrap');

    personCheck();
    deliveryCheck();

    $('[name="maksatajs"]', wrap).change(function () {
        personCheck();
    });

    $('[name="delivery-type"]', wrap).change(function () {
        deliveryCheck();
    });

    function deliveryCheck() {
        var selectedOption = $('[name="delivery-type"] option', wrap).filter(function () {
            return $(this).prop('selected');
        })
        $('.address-wrap').hide();
        $('.address-wrap.' + selectedOption.data('address-class')).show();
    }

    function personCheck() {
        var checkedRadio = $('[name="maksatajs"]', wrap).filter(function () {
            return $(this).prop('checked');
        });

        if ($(checkedRadio).val() == "fiziska") {
            $('.fiz-wrap').show();
            $('.jur-wrap').hide();
        } else {
            $('.jur-wrap').show();
            $('.fiz-wrap').hide();
        }
    }
}

function initFooter() {
    var wrap = $('footer');

    $('.dropdown-toggle', wrap).click(function () {
        $(this).toggleClass('clicked').parent().siblings('.navigation').slideToggle(300);
    });
}

function initMobile() {
    initSearch();
    initMobileMenu();
    initMobileCart();
    initMobileFilters();

    function initMobileMenu() {
        var mobileMenu = $('#mobile-nav');
        var bottomItems = $('header .bottom .nav-item');
        var topItems = $('header .top .nav-item');

        mobileMenu.append(bottomItems.clone());
        mobileMenu.append(topItems.clone());

        $('#mobile-nav').on('click touch tap', function (event) {
            var events = $._data(document, 'events') || {};
            events = events.click || [];
            for (var i = 0; i < events.length; i++) {
                if (events[i].selector) {

                    if ($(event.target).is(events[i].selector)) {
                        events[i].handler.call(event.target, event);
                    }

                    $(event.target).parents(events[i].selector).each(function () {
                        events[i].handler.call(this, event);
                    });
                }
            }
            event.stopPropagation();
        });
    }

    function initSearch() {
        var wrap = $('header .mobile-search-wrap');
        var toggleSearch = $('.mobile-search-toggle', wrap);
        var mobileInput = $('.mobile-search-input', wrap);
        var overlay = $('.overlay', wrap);

        toggleSearch.click(function () {
            if (wrap.hasClass('open')) {
                $(this).parent().submit();
            } else {
                wrap.addClass('open');
                return false;
            }
        });

        overlay.click(function () {
            wrap.removeClass('open');
        });
    }

    function initMobileFilters() {
        var wrap = $('.shop-menu');
        var toggle = $('.toggle-shop-menu', wrap);
        var subject = $('.toggle-wrap', wrap);

        toggle.click(function(){
            wrap.toggleClass('show');
            subject.slideToggle(300);
        });
    }
}

var cartTableWidth = $('.cart-table').eq(0).width();

function initMobileCart() {
    var table = $('.cart-table').eq(0);
    var headers = $('th', table);
    var rows = $('tr', table);
    var newTable = '<div class="new-table">';


    if (cartTableWidth <= table.parent().width()) {
        table.show();
        table.next('.new-table').hide();
        return;
    } else {
        if (!$(this).hasClass('inited')) {
            cartTableWidth = table.width();
        }
        if (table.hasClass('inited')) {
            table.hide();
            table.next('.new-table').show();
            return;
        }
    }

    rows.each(function () {
        var row = $(this);
        if ($('th', row).length > 0) {
            return;
        }
        var cells = $('td', row);
        newTable += '<table class="table-row" data-product-id="'+row.data('product-id')+'">';
        newTable += "<tr>";
        cells.slice(0, 3).each(function () {
            var cellIndex = cells.index($(this));
            var colspan = cellIndex == 2 ? 'colspan="2"' : '';

            newTable += '<td class="td" ' + colspan + '>' + $(this).html() + '</td>';
        });
        newTable += "</tr>";

        newTable += "<tr>";
        cells.slice(3, 6).each(function () {
            var cellIndex = cells.index($(this)) - 2;
            var colspan = cellIndex == 1 ? 'colspan="2"' : '';

            newTable += '<td class="td" ' + colspan + '><div class="cell-heading">' + headers.eq(cellIndex, headers).html() + '</div>' + $(this).html() + '</td>';
        });
        newTable += "</tr>";
        newTable += '</table>';
    });

    newTable += '</div>';

    table.after(newTable);
    table.addClass('inited');
    table.hide();
}

var tables = $('.formatedtext table');
var tableWidths = {};

function initTables() {

    tables.each(function () {
        if (!$(this).hasClass('inited')) {
            tableWidths[$(this).index()] = $(this).width();
        }
        if (tableWidths[$(this).index()] <= $(this).parent().width()) {
            $(this).show();
            $(this).next('.new-table').hide();
            return;
        } else {
            if ($(this).hasClass('inited')) {
                $(this).hide();
                $(this).next('.new-table').show();
                return;
            }
        }

        var table = $(this);
        var headers = $('th', table);
        var rows = $('tr', table);
        var newTable = '<div class="new-table">';

        rows.each(function () {
            var row = $(this);
            if ($('th', row).length > 0) {
                return;
            }
            var cells = $('td', row);
            newTable += '<table class="table-row">'

            cells.each(function () {
                var cellIndex = cells.index($(this));
                newTable += '<tr class="cell-row">';
                newTable += '<td class="th">' + headers.eq(cellIndex, headers).html() + '</td>';
                newTable += '<td class="td">' + $(this).html() + '</td>';
                newTable += '</tr>';

            });

            newTable += '</table>';
        });

        newTable += '</div>';

        table.after(newTable);
        table.addClass('inited');
        table.hide();
    });
}

var leftContent = $('.main-content.product-info');
var rightContent = leftContent.siblings('.right-content').eq(0);
var mobilePlace = $('.product-info .product-main');

function initProduct(){

    if($(window).width() <= 575){
        rightContent.appendTo(mobilePlace);
    }else{
        rightContent.detach();
        leftContent.after(rightContent);

    }
}